import { Modal as MUIModal } from "@mui/material";
import classNames from "classnames";
import { CloseButton } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { ReactNode } from "react";
import "./Modal.scss";

export type ModalSize = "md" | "lg";

interface ModalProps {
    open: boolean;
    onCancel: () => void;
    title: string;
    children: ReactNode;
    footer: ReactNode;
    /** Default `md` matches the standard modal. Can use lg for larger modals. */
    size?: ModalSize;
    /** When true, the body is a scroll container (`overflow-y: auto`) when height is constrained. */
    scrollBody?: boolean;
    /** When true, the body uses block layout instead of the default flex row. */
    blockLayout?: boolean;
    className?: string;
    bodyClassName?: string;
}

function Modal({
    open,
    title,
    children,
    footer,
    onCancel,
    size = "md",
    scrollBody = false,
    blockLayout = false,
    className,
    bodyClassName,
}: ModalProps) {
    return (
        <MUIModal open={open} onClose={onCancel}>
            <div className={classNames("modal", size === "lg" && "modal--lg", className)}>
                <div className="modal__header">
                    <Header>{title}</Header>
                    <CloseButton onClick={onCancel} />
                </div>
                <div
                    className={classNames(
                        "modal__body",
                        blockLayout && "modal__body--block",
                        scrollBody && "modal__body--scroll",
                        bodyClassName
                    )}
                >
                    {children}
                </div>
                <div className="modal__footer">{footer}</div>
            </div>
        </MUIModal>
    );
}

export default Modal;
